export const FILTER_DRAWER_WIDTH = 240;
export const FILTER_DRAWER_TRANSITION_DURATION = 150;

/** Fixed height of a collapsed catalog row (and each expanded period sub-row), in px. */
export const COLLAPSED_ROW_HEIGHT = 24;
/** Background of an expanded row + its period panel, so they read as one block. */
export const EXPANDED_ROW_BG = '#1A224D';
/**
 * Fixed-width slot reserved before every spot Title so the expand chevron never
 * pushes into the title text and all titles align whether or not they expand.
 */
export const TITLE_CHEVRON_GUTTER = 20;
